export default __webpack_public_path__ + "static/media/check-active.6bdc729b.svg";